import React from 'react'
import PropTypes from 'prop-types'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { HStack, useTheme } from '@chakra-ui/react'
import Toast from '../Toast/Toast'
import ButtonSelector from '../ButtonSelector/ButtonSelector'

export default function ButtonSelectorList({
  options,
  onSelectedChange,
  selected,
  stackProps = {},
  buttonVariant,
  variant,
}) {
  const {
    colors: { primary },
  } = useTheme()
  const defaultTextColor = variant === 'white' ? '#FFFFFF' : null
  return (
    <HStack {...stackProps}>
      {options.map((option, index) => (
        <Toast
          key={option.label}
          as="button"
          variant={
            buttonVariant && selected.label !== option.label
              ? buttonVariant
              : null
          }
          onClick={() => onSelectedChange(index)}
          bgColor={
            selected?.label === option.label || option.alwaysColored
              ? option.color || primary.base
              : null
          }
        >
          <ButtonSelector
            selected={selected?.label === option.label}
            icon={option?.icon || faCheckCircle}
            label={option.label}
            defaultTextColor={defaultTextColor}
          />
        </Toast>
      ))}
    </HStack>
  )
}

ButtonSelectorList.propTypes = {
  buttonVariant: PropTypes.string,
  onSelectedChange: PropTypes.func,
  options: PropTypes.array,
  selected: PropTypes.shape({
    label: PropTypes.string,
  }),
  stackProps: PropTypes.object,
  variant: PropTypes.string,
}
